import React from 'react'
import { CFooter } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <a href="" target="_blank" rel="noopener noreferrer">
          LMS
        </a>
        <span className="ms-1">&copy; 2023 Edulab.</span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Powered by</span>
        <a href="" target="_blank" rel="noopener noreferrer">
          Edulab 🖤
        </a>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
